import { render, staticRenderFns } from "./welfare-bar.vue?vue&type=template&id=342c9a8c&scoped=true&"
import script from "./welfare-bar.vue?vue&type=script&lang=js&"
export * from "./welfare-bar.vue?vue&type=script&lang=js&"
import style0 from "./welfare-bar.vue?vue&type=style&index=0&id=342c9a8c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "342c9a8c",
  null
  
)

export default component.exports